// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeFanFollowFollowingListBody = {
  cursor?: string | null;
  limit?: number | null;
};

export type typeFanFollowFollowingListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      accountId: string;
      username: string;
      displayName: string;
      photoUrl?: string | null;
      followState: "requested" | "following";
      since: string;
    }[];
    nextCursor?: string | null;
  };
};

export type typeFanFollowFollowingListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeFanFollowFollowingListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeFanFollowFollowingListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaFanFollowFollowingListBody = {
  type: "object",
  properties: {
    cursor: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    limit: { oneOf: [{ type: "integer" }, { enum: [null] }] },
  },
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createFanFollowFollowingList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaFanFollowFollowingListBody);
  }

  return async function postFanFollowFollowingList(
    payload: typeFanFollowFollowingListBody,
  ): Promise<
    typeFanFollowFollowingListOutput200 | typeFanFollowFollowingListOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postFanFollowFollowingList" failed before calling the network. #86e3723df141`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#86e3723df141" },
        },
        data: null,
      } as typeFanFollowFollowingListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/fan-follow/following-list`,
      httpMethod: "POST",
      options,
    })) as
      typeFanFollowFollowingListOutput200 | typeFanFollowFollowingListOutput400;
  };
}
